import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, first } from 'rxjs';

import { EchoTokenService } from '../echo-token/echo-token.service';
import { QuestInstanceService } from '../quest-instance/quest-instance.service';

@Injectable({
  providedIn: 'root',
})
export class RouterNavigationService {
  private location = inject(Location);
  private router = inject(Router);
  private echoTokenService = inject(EchoTokenService);
  private questInstanceService = inject(QuestInstanceService);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((navigationEnd) => {
        if (navigationEnd.urlAfterRedirects.startsWith('/echoes')) {
          this.checkAndCleanEchoTokenFromUrl();
        } else {
          this.echoTokenService.clearToken();
        }

        this.questInstanceService
          .getCurrentQuestInstance()
          .pipe(first())
          .subscribe((questInstance) => {
            if (
              questInstance &&
              !navigationEnd.urlAfterRedirects.startsWith(`/projects/${questInstance.id}`)
            ) {
              this.questInstanceService.setCurrentQuestInstance(undefined);
            }
          });
      });
  }

  checkAndCleanEchoTokenFromUrl(): void {
    const url = new URL(window.location.href);
    const echoToken = url.searchParams.get('echoToken');
    if (echoToken) {
      // echo token guard saved the token, now we clean the URL
      url.searchParams.delete('echoToken');
      this.location.replaceState(url.pathname + url.search);
    }
  }
}
